<template>
  <div class="text-standard">
    <div class="h-fiftyvh md:h-screen console bg-cover bg-center relative">
      <div class="bottom-0 absolute w-full">
        <div class="container mx-auto px-5 mb-8">
          <p class="mb-8 text-base md:text-2xl">
            Anamorphic Console by Asher Israelow
          </p>
          <img loading="lazy" class="hidden md:block" src="~/assets/img/ico-arrow-black.svg">
        </div>
      </div>
    </div>
    <div class="container mx-auto flex flex-col md:flex-row pt-10 md:pt-16">
      <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0">
        <iframe
          allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true"
          style="width:100%;" class="h-fiftyvh lg:h-full"
          :src="'https://cdn.myarstudio.cloud/f2f01834-6984-4e4d-bd20-8e7586523cf0/Playground/Products/236920ea-da01-511b-8038-ea80140a9b42/default/75852c01-3b33-53c7-afa7-6a03b2172e58/index.html?language=' + $i18n.locale"
        />
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2">
        <h2 class="text-standard fullhd:text-55px laptop:text-55px font-bold mb-12 md:w-full laptop:w-full md:text-4xl leading-normal laptop:leading-tight">
          Anamorphic Console, <br>2014
        </h2>
        <p>Solid walnut and brass inlay compose hidden geometries. First found in the 15th Century, anamorphic projection was used to pass secret messages or obscure visions within paintings. Now the first console in a series.<br><br>
        </p><p>This is an example of integration of 3D contents inside a website. It is intended to suggest ideas of applications on product pages of the outputs of My AR Studio. All the information and images in this page come from asherisraelow.com/anamorphic-console and dimensiva.com.</p>
        <p>For further information see <a class="text-orange underline" target="_blank" href="/learn/documentation/distribute/universal-viewer/">our documentation</a></p>
      </div>
    </div>
    <div class="container mx-auto mt-16 laptop:my-150px">
      <div class="grid grid-cols-1 md:grid-cols-2">
        <img loading="lazy" src="~/assets/img/examples/console-1.webp">
        <img loading="lazy" src="~/assets/img/examples/console-2.webp">
        <img loading="lazy" src="~/assets/img/examples/console-3.webp">
        <img loading="lazy" src="~/assets/img/examples/console-4.webp">
      </div>
    </div>
    <div class="container mx-auto flex flex-col md:flex-row py-24 laptop:py-0">
      <div class="laptop:w-6/12 p-5 md:p-0 md:mx-8 laptop:p-0 md:w-3/6 lg:min-h-0 laptop:pl-12">
        <p class="mb-8">55 (L) x 22 (W) x 18 (H) inches</p>
        <p class="mb-8 text-lightgray">55 (L) x 22 (W) x 18 (H) inches</p>
        <p class="mb-8 text-lightgray">55 (L) x 22 (W) x 18 (H) inches</p>
      </div>
      <div class="laptop:w-5/12 p-5 md:p-0 laptop:pl-0 laptop:mx-24 md:mx-8 md:w-1/2">
        <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi.<br><br>
          Sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.
        </p>
        <div class="w-full mt-24">
          <img loading="lazy" class="mx-auto" src="~/assets/img/examples/console-scheme.webp">
        </div>
      </div>
    </div>

    <TryIt />
    <div class="hidden md:block">
      <img loading="lazy" class="mx-auto" src="~/assets/img/examples/console-schema.webp">
    </div>
  </div>
</template>

<script lang="ts">
import TryIt from '@/components/TryIt.vue'

export default defineNuxtComponent({
  components: { TryIt }
})
</script>

<style scoped>
.console {
  background-image: url("~/assets/img/examples/anamorphic-hero.webp");
}
</style>
